import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (active, isCustodial) => isCustodial(active);
export default defineSelectorResultFunction({
    id: 'activeIsCustodial',
    resultFunction,
    dependencies: [
        { selector: 'active' },
        { selector: 'isCustodial' },
    ],
});
